import PropTypes from 'prop-types';
import React from 'react';

import trainTime from '../../lib/TrainTime';
import t from '../../lib/I18n';
import TicketOffice from '../../records/TicketOffice';
import { TicketOfficeHours } from '../../constants/AppConstants';

import Icon from '../general/Icon';
import BAlert from '../general/BAlert';

export default class OpeningStatus extends React.PureComponent {
    static propTypes = {
        loadingTicketOfficeDetails: PropTypes.bool,
        ticketOffice: PropTypes.instanceOf(TicketOffice)
    }

    static defaultProps = {
        loadingTicketOfficeDetails: false,
        ticketOffice: null
    }

    _getSelectedStationOpeningTime() {
        const { ticketOffice } = this.props;

        if (ticketOffice) {
            return ticketOffice.getOpenStatus(trainTime());
        }

        return TicketOfficeHours.NO_OFFICE;
    }

    renderStationOpenStatusMessage(openStatus) {
        let alertType;
        switch (openStatus) {
            case TicketOfficeHours.OPEN:
                alertType = 'success';
                break;
            case TicketOfficeHours.CLOSED:
                alertType = 'danger';
                break;
            case TicketOfficeHours.NO_OFFICE:
                alertType = 'danger';
                break;
            default:
                alertType = 'warning';
        }

        return (
            <BAlert type={ alertType } className="text-center">
                <Icon icon="clock" className="opening-clock" />&nbsp;
                <span>{ t(`stationFinder.status.${openStatus}`) }</span>
            </BAlert>
        );
    }

    render () {
        if (this.props.loadingTicketOfficeDetails) {
            return (
                <div className="text-center b-alert">
                    <i className="otrl otrl-spinner otrl-spin"/>
                </div>
            );
        }

        const openStatus = this._getSelectedStationOpeningTime();

        return (
            <div className='stationFinder__modal-opening-status'>
                { this.renderStationOpenStatusMessage(openStatus) }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/stationFinder/OpeningStatus.js